module.exports = __webpack_public_path__ + "static/media/Maipu.9b901f04.png";